import React, { useEffect, useState } from 'react'
import { OnboardingView } from '../../views';
import { CompanyService, LocalStorageService, MessageService, Auth0Service, OnboardingUserService } from '../../../services';
import ChangePasswordForm from '../../views/onboarding/steps/changePasswordForm';
import PersonalDataForm from '../../views/onboarding/steps/personalDataForm';
import SummaryView from '../../views/onboarding/steps/summaryView';
import ValidateOTPForm from '../../views/onboarding/steps/validateOtpForm';
import { ModalUtil } from '../../pures';
import { useTranslation } from 'react-i18next';

const url = process.env.REACT_APP_ETICKET_API;
const localStorageService = new LocalStorageService();
// let token = localStorageService.getLocalStorageItem("token")
// if (token) token = token.idToken

const messageService = new MessageService(url);
const companyService = new CompanyService(url);
const onboardingUserService = new OnboardingUserService(url)

function OnboardingUserAction(props) {
    const { token, email } = props
    const [user, setUser] = useState(null);

    const { t } = useTranslation();
    const modalUtil = new ModalUtil()
    const [loading, setLoading] = useState(true)
    const [errorMessage, setErrorMessage] = useState("")
    const [currentStep, setCurrentStep] = useState(0)

    const [stepsContent, setStepsContent] = useState([
        {
            number: 0,
            icon: "k-i-email",
            component: ValidateOTPForm,
            name: "validateOTP"
        },
        {
            number: 1,
            icon: "k-i-user",
            component: PersonalDataForm,
            name: "personalData"
        },
        {
            number: 2,
            icon: "k-i-password",
            component: ChangePasswordForm,
            name: "changePassword"
        },
        {
            number: 3,
            icon: 'k-i-check',
            component: SummaryView,
            name: "summary"
        },
    ]);
    const stepsStepper = stepsContent.map((step) => ({ icon: step.icon }))

    const moveStep = (valueOrForward) => {
        window.scroll(0, 0)
        if (typeof valueOrForward === "boolean") {
            setCurrentStep(prev => valueOrForward ? prev + 1 : prev - 1)
        } else {
            setCurrentStep(valueOrForward)
        }
    }

    const onReSendMessage = async () => {
        try {
            modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))
            await messageService.sendEmailMessageOnboardingUser(token);
            modalUtil.showModal('success', t("register.sendCodeSuccess"), t('modal.pure.title.success'))
        } catch (error) {
            modalUtil.showModal('error', t("register.sendCodeErrror"), error.message || t("modal.pure.title.error"))
        }
    }

    const validateOTP = async (codeEntered) => {
        try {
            modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))
            const codeValidator = await messageService.validateEmailMessageOnboardingUser(
                codeEntered,
                token
            );
            if (codeValidator.data === "Validated") {
                await modalUtil.showModal('success', t("register.codeValidationSuccess"), t('modal.pure.title.success'))
                moveStep(true)
            } else {
                throw new Error(codeValidator.data)
            }
        } catch (error) {
            modalUtil.showModal('error', t("register.codeValidationError"), error.message || t("modal.pure.title.error"))
        }
    }

    const validatePersonalData = async (personalData) => {
        try {
            modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))
            await companyService.updateUserProfile(personalData, token, 'internal')
            await modalUtil.showModal('success', t("register.updateDataSuccess"), t('modal.pure.title.success'))

            setUser((prev) => ({ ...prev, ...personalData }))
            moveStep(true)
        } catch (error) {
            modalUtil.showModal('error', t("register.updateDataError"), error.message || t("modal.pure.title.error"))
        }
    }

    const validateChangePassword = async (passwordData) => {
        const auth0Service = new Auth0Service()

        try {
            const { password, confirmPassword } = passwordData

            let passwordValue = password.trim();
            let confirmPasswordValue = confirmPassword.trim();

            // Validate that both passwords are equal
            if (!(passwordValue === confirmPasswordValue)) {
                throw new Error(t("login.action.errorPass"));
            }

            modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))
            // Calling service to change password
            let changePassword = await auth0Service.forgotPassword(
                confirmPasswordValue,
                token,
                'internal',
                true
            );
            if (!(Number(changePassword.data.statusCode) === 200)) throw new Error(changePassword.data.message);

            localStorage.setItem('user-changed-password', true)

            await modalUtil.showModal('success', t("register.updateDataSuccess"), t('modal.pure.title.success'))

            moveStep(true)
        } catch (error) {
            modalUtil.showModal('error', t("register.updateDataError"), error.message || t("modal.pure.title.error"))
        }
    }

    const goToApp = () => {
        localStorage.clear()
        window.location.href = window.location.pathname
    }

    const onSubmitStep = (data) => {
        switch (stepsContent[currentStep].name) {
            case "validateOTP":
                validateOTP(data);
                break;
            case "personalData":
                validatePersonalData(data)
                break;
            case "summary":
                goToApp();
                break;
            case "changePassword":
                validateChangePassword(data);
                break;
        }
    }

    const getAndSetCurrentStep = async () => {
        let currentStep = await onboardingUserService.getStepOnboarding(token)
        let user = { email }
        if (currentStep?.statusCode === 200) {
            currentStep = currentStep.data
            const skipSteps = currentStep?.skipSteps || []
            let newSteps = stepsContent.filter(step => !skipSteps.includes(step.name))
            if (currentStep?.stepOnboarding) {
                const currentStepName = currentStep?.stepOnboarding?.name;
                const currentStepIndex = newSteps.findIndex(step => step.name === currentStepName)
                setCurrentStep(currentStepIndex)
            }
            setStepsContent(newSteps)
            if (currentStep && currentStep.user && currentStep.user.firstName && currentStep.user.firstLastName && currentStep.user.secondLastName) user = currentStep.user
        }

        setUser(user)
        setLoading(false)
    }

    useEffect(() => {
        getAndSetCurrentStep()
    }, [])

    return (
        <OnboardingView
            loading={loading}
            errorMessage={errorMessage}
            user={user}
            stepsStepper={stepsStepper}
            stepsContent={stepsContent}
            moveStep={moveStep}
            currentStep={currentStep}
            onSubmitStep={onSubmitStep}
            onReSendMessage={onReSendMessage}
            type={'onboarding-user'}
        />
    )
}

export default OnboardingUserAction